import $ from "jquery";
import MicroModal from "micromodal";
class Modal {
    constructor() {
        this.isOpen = false;
        this.lastScrollPosition = 0;
        this.scrollThreshold = 50;
        this.handleScroll = () => {
            if (this.isOpen)
                return; // モーダルが開いている時は処理しない
            const currentScrollPosition = window.scrollY || document.documentElement.scrollTop;
            if (!this.header)
                return;
            // スクロール方向の判定
            if (currentScrollPosition > this.lastScrollPosition &&
                currentScrollPosition > this.scrollThreshold) {
                // 上スクロール時
                this.header.classList.add("header-hidden");
                this.header.classList.remove("header-visible");
            }
            else {
                // 下スクロール時
                this.header.classList.remove("header-hidden");
                this.header.classList.add("header-visible");
            }
            this.lastScrollPosition = currentScrollPosition;
        };
        this.btn = document.querySelectorAll(".modal-btn");
        this.header = document.querySelector("#mainHeader");
        this.modalOptions = {
            //disableScroll: true,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
            onClose: (modal) => {
                console.info(`${modal === null || modal === void 0 ? void 0 : modal.id} is hidden`);
                this.isOpen = false;
                //bodyにmenu-openクラスがある場合は削除
                if (document.body.classList.contains("menu-open")) {
                    document.body.classList.remove("menu-open");
                }
            },
            onShow: (modal) => {
                console.info(`${modal === null || modal === void 0 ? void 0 : modal.id} is shown`);
                this.isOpen = true;
                //bodyにmenu-openクラスがない場合は追加
                if (!document.body.classList.contains("menu-open")) {
                    document.body.classList.add("menu-open");
                }
            },
        };
        this.clickEvent();
        //this.initScrollEvent();
    }
    toggleModal() {
        if (this.isOpen) {
            MicroModal.close("modal-menu");
        }
        else {
            MicroModal.show("modal-menu", this.modalOptions);
        }
    }
    clickEvent() {
        if (!this.btn)
            return;
        this.btn.forEach((btnElement) => {
            btnElement.addEventListener("click", (e) => {
                e.preventDefault();
                this.toggleModal();
            });
        });
    }
    debounce(func, wait) {
        let timeout = null;
        return (...args) => {
            const later = () => {
                timeout = null;
                func.apply(this, args);
            };
            if (timeout)
                clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
    initScrollEvent() {
        const debouncedScroll = this.debounce(this.handleScroll, 100);
        window.addEventListener("scroll", debouncedScroll);
    }
}
new Modal();
$(function () {
    $(".toggle-menu").on("click", function () {
        const width = window.innerWidth;
        if (width < 768) {
            $(this).parents(".toggle-cnt").find(".toggle-item").slideToggle();
            $(this).toggleClass("active");
        }
    });
});
